import { FC } from "react"
import { ContactFormDetails } from "../../../../../../../../types"
import Input from "../../../../../../form/input"
import BBSwitch from "../../../../../../form/Switch"

interface Props {
  values: ContactFormDetails
  setConfigField: (field: string, value: any) => void
}

const ContactFormGeneral: FC<Props> = ({ values, setConfigField }) => {
  const { config } = values

  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <h3 className="text-sm font-semibold text-gray-700">Content</h3>
        <Input
          name="config.title"
          label="Form title"
          placeholder="Interested In Learning More?"
        />
        <Input
          name="config.subtitle"
          label="Subtitle"
          placeholder="Get in touch with a loan originator today!"
        />
        <Input
          name="config.submit.label"
          label="Submit button label"
          placeholder="Get in Touch"
        />
      </div>

      <div className="border-t border-gray-100 pt-6 space-y-1">
        <h3 className="text-sm font-semibold text-gray-700 mb-4">
          Display settings
        </h3>
        <div className="divide-y divide-gray-100 rounded-xl border border-gray-100 overflow-hidden">
          <div className="px-4 py-3">
            <BBSwitch
              label="Show left column"
              description="Display a decorative left column alongside the form"
              enabled={config?.show_left_column ?? false}
              setEnabled={v => setConfigField("show_left_column", v)}
            />
          </div>
          <div className="px-4 py-3">
            <BBSwitch
              label="Enable CAPTCHA"
              description="Require CAPTCHA verification on form submission"
              enabled={config?.captcha_enabled ?? false}
              setEnabled={v => setConfigField("captcha_enabled", v)}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContactFormGeneral
